import { Typography } from '@mui/material'

import { TransElement } from './types'

export const Line = ({ text }: { text: string | TransElement }): React.JSX.Element => (
  <Typography
    sx={{ whiteSpace: 'pre-wrap' }}
    variant='body2'
  >
    {text}
  </Typography>
)
